module.exports = __webpack_public_path__ + "static/org_idac-bf79a8e18403d47919501639b378d0ec.png";